import React, { useState } from 'react';
import { auth } from '../firebase';
import { signInWithEmailAndPassword } from 'firebase/auth';
import { ShieldAlert, Lock, Mail } from 'lucide-react';

const AdminLogin = ({ onLoginSuccess }) => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleLogin = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    
    try {
      // Direct handshake authentication call to the Firebase Auth engine
      await signInWithEmailAndPassword(auth, email.trim(), password);
      if (onLoginSuccess) onLoginSuccess();
    } catch (err) {
      setError('Access Denied. Invalid administrative credentials.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="w-full min-h-screen bg-[#fafafa] flex flex-col justify-center items-center p-4 font-sans antialiased">
      <div className="w-full max-w-md bg-white border border-slate-200/80 rounded-2xl p-6 md:p-8 shadow-xl shadow-slate-100/40 text-left space-y-6">
        <div>
          <div className="flex items-center gap-2">
            <Lock className="text-slate-900" size={20} />
            <h1 className="text-lg font-bold tracking-tight uppercase text-slate-900">Security Gateway</h1>
          </div>
          <p className="text-[10px] font-bold text-slate-400 uppercase tracking-widest mt-0.5">Authorized Personnel Only</p>
        </div>

        <form onSubmit={handleLogin} className="space-y-4">
          <div className="space-y-1.5">
            <label className="text-[10px] font-bold text-slate-500 uppercase tracking-wider flex items-center gap-1.5">
              <Mail size={12} /> Root Email Identifier
            </label>
            <input 
              type="email" required placeholder="your-email@domain.com"
              className="w-full px-3.5 py-2.5 bg-slate-50/50 border border-slate-200 rounded-xl text-xs font-semibold outline-none focus:border-slate-900 focus:bg-white transition-all text-slate-900"
              value={email} onChange={e => setEmail(e.target.value)}
            />
          </div>

          <div className="space-y-1.5">
            <label className="text-[10px] font-bold text-slate-500 uppercase tracking-wider flex items-center gap-1.5">
              <Lock size={12} /> Cryptographic Passphrase
            </label>
            <input 
              type="password" required placeholder="••••••••"
              className="w-full px-3.5 py-2.5 bg-slate-50/50 border border-slate-200 rounded-xl text-xs font-semibold outline-none focus:border-slate-900 focus:bg-white transition-all text-slate-900"
              value={password} onChange={e => setPassword(e.target.value)}
            />
          </div>

          {error && (
            <div className="p-3.5 bg-rose-50 text-rose-900 border border-rose-200 rounded-xl text-xs font-bold flex items-start gap-2">
              <ShieldAlert size={14} className="text-rose-600 shrink-0 mt-0.5" />
              <span>{error}</span>
            </div>
          )}

          <button
            type="submit" disabled={loading}
            className="w-full h-[42px] bg-slate-900 hover:bg-slate-800 disabled:bg-slate-700 text-white font-bold text-xs uppercase tracking-wider rounded-xl transition-all flex items-center justify-center gap-2 cursor-pointer shadow-xs"
          >
            {loading ? (
              <svg className="animate-spin h-4 w-4 text-white" fill="none" viewBox="0 0 24 24">
                <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" />
                <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z" />
              </svg>
            ) : "Authenticate Console"}
          </button>
        </form>
      </div>
    </div>
  );
};

export default AdminLogin;